import React from "react";
import "./Contact_Us.css";
import Contact_Form from "./contact_form/Contact_Form";
import Common_Banner from "../common-components/common_banner/Common_Banner";
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";

const Contact_Us = () => {
  return (
    <div className="Contact_Us">
      {/* <Common_Banner imgSrc="/assets/images/contact_us/banner.png"/> */}
      <Common_Banner_2
        imgSrc="/assets/images/about_us/banner/Banner-03.png"
        title_text="Contact Us"
      />
      <Contact_Form />
    </div>
  );
};

export default Contact_Us;
